import { useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { MainArea, Page, Gap } from '@salecycle/ui-component-library';
import { ClientLevel } from 'core/types';
import { UploadFileList } from '../components/UploadFileList';
import { ImportConsentProvider } from '../context/ImportConsentContext';
import { ConsentFileData } from '../types';
import { useTranslation } from 'react-i18next';

export const ConsentUploadPage = () => {
  const { t } = useTranslation('fileManagement');
  const { clientLevel, clientId } = useParams<{ clientLevel: ClientLevel; clientId: string }>();
  const { uploadFiles } = useLocation<{ uploadFiles: ConsentFileData[] }>()?.state ?? {};
  const providerProps = { clientId, clientLevel, uploadFiles };

  useEffect(() => {
    const handleBeforeUnload = e => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <ImportConsentProvider {...providerProps}>
      <MainArea>
        <Page heading={t('upload.heading')} padding={0}>
          <Gap top={22} />
          <UploadFileList />
        </Page>
      </MainArea>
    </ImportConsentProvider>
  );
};
